import React, { useEffect } from "react";
import {
  ButtonBase,
  ThemeProvider,
  theme,
  BetaForm as useBetaForm,
  TextAreaBase,
} from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";

const newTheme = {
  ...theme,
  variants: {},
};
// "bg-green-50 text-green-500"
// "bg-red-50 text-red-500"
export default function CancellationModal(props: any) {
  const form = useBetaForm({
    comment: "",
  });

  const form_constraints = {
    comment: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div
            className={
              "absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900"
            }
          >
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className={"relative border-b " + props.color}>
            <div className="px-4 lg:px-8">
              <div className="relative py-6 text-center">
                <h2 className="text-xl font-semibold tracking-tight">
                  {props.heading}
                </h2>
              </div>
            </div>
          </div>
          <div className="p-4 text-center max-w-lg">
            <div className="mt-2 min-h-max text-base text-gray-500">
              {props.description}
            </div>
          </div>

          <div className="flex justify-center items-center py-4 border-t">
            <ButtonBase
              variant="primary"
              type="button"
              label="Ok"
              onClick={() => {
                props.callback();
                props.onAction("no");
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                padding: "px-8 py-3",
              }}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
